<h2 mat-dialog-title>Status History</h2>
<mat-dialog-content>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Status</th>
          <th>Remarks</th>
          <th>Status Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of statusList">
          <td>{{ item.status }}</td>
          <td>{{ item.remarks }}</td>  
          <td>{{ item.statusDate }}</td>
        </tr>
      </tbody>
    </table>
  </div>  
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
